import { Info } from "lucide-react";

export function FinePrint({ children, className = "" }) {
  return (
    <p className={`flex items-start gap-1.5 text-[11px] leading-relaxed text-slate-400 ${className}`} data-testid="fine-print">
      <Info className="mt-0.5 h-3 w-3 flex-shrink-0" />
      <span>{children}</span>
    </p>
  );
}
